import { ComponentPropsWithoutRef, useEffect } from "react";
import { twMerge } from "tailwind-merge";
import { useStepButtonScheduleDetailV2 } from "./useStepButtonScheduleDetailV2";

const STEPS = [
  { number: 1, label: "Detalhes" },
  { number: 2, label: "Faturas" },
  { number: 3, label: "Histórico" },
  { number: 4, label: "Incidentes" },
];

interface IStepButtonScheduleDetailV2Props extends ComponentPropsWithoutRef<"div"> {
  getFormNumber?: (n: number) => void;
}

export const StepButtonScheduleDetailV2 = ({
  getFormNumber,
  className,
  ...rest
}: IStepButtonScheduleDetailV2Props) => {
  const { step, setStep } = useStepButtonScheduleDetailV2();

  useEffect(() => {
    getFormNumber && getFormNumber(step);
  }, [step]);

  return (
    <div
      {...rest}
      className={twMerge(
        "flex w-full items-center gap-[15px] overflow-x-auto rounded-full border border-solid border-[#e5e5ea] p-2.5 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.078)]",
        className,
      )}
    >
      {STEPS.map(({ number, label }) => (
        <button
          key={number}
          type="button"
          onClick={() => setStep(number)}
          className={twMerge(
            "shrink-0 whitespace-nowrap rounded-full px-5 py-2.5 text-center font-['Mulish'] text-base font-normal text-[#2d2d2d] transition-all duration-300 sm:flex-1",
            step === number && "bg-[#20332f] text-white",
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
